import type React from 'react';

import { Box } from '@mui/material';

export interface OrdInlineFieldsProps {
  children: React.ReactNode;
}

export const OrdInlineFields = ({ children }: OrdInlineFieldsProps): React.ReactElement => (
  <Box
    sx={(theme) => ({
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--Grid-columnSpacing, 16px)',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    })}
  >
    {children}
  </Box>
);
